/* USER EDITOR */
Vue.component('usereditor',{
    template:'#usereditor-template',
    data:function(){
        return{
            user: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false,
            companies:[],
            divisions:[],
            assigned_companies:[],
            roles:[],
            assigned_roles:[],
            user_is_freelancer:0,
            user_basic_role: 'user',
            account_managers: [],
            projects:[],
            migration_complete:false,
            currently_removing: false,
            active_division_titles: [],
            user_division_titles: [],
            original_email: null
        };
    },
    created:function() {

        activeInstance = this;

        var id = $('#content_wrapper').attr('data-id');

        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/user/list/'+id).then(function(response){
            $('body').LoadingOverlay("hide");

            if (response.data.error) {
                errorNotification(response.data.error);
            }

            $(response.data[0].shippingdata).each(function(index,record){
                record.locked = true;
            });

            $(response.data[0].personaldata).each(function(index,record){
                record.locked = true;
            });

            $(response.data[0].invoicedata).each(function(index,record){
                record.locked = true;
            });

            console.log(response.data[0]);

            $.each(response.data[0].titles, function(i, item) {
                activeInstance.user_division_titles.push(item.division_title_id);
            });

            activeInstance.user = response.data;

            activeInstance.original_email = response.data[0].email;

            activeInstance.getAllCompany();
            activeInstance.getDivisions();
            console.log(response);
            activeInstance.getAvailableRoles();

            setTimeout(function(){
                $('#field_first_business_day').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
            },100);

            setTimeout(function(){
                $('#field_last_business_day').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
            },100);

        }).bind(this);
    },
    watch: {
        'user[0].division_id': function() {
            this.getDivisionTitles();
        },
        roles: {
            handler: function() {

                for(var i = 0, i_ = this.roles.length; i < i_; i ++) {
                    if (this.roles[i].name == 'user' || this.roles[i].name == 'freelancer' || this.roles[i].name == 'inactive') {
                        if (this.roles[i].selected) {
                            this.user_basic_role = this.roles[i].name;
                            break;
                        }
                    }
                }
            },
            deep: true
        },
        user_basic_role: function(val) {
            console.info("changed user_basic_role");
            var user_role = val;

            if (user_role == 'user') {

                setTimeout(function(){
                    $('#field_first_business_day').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu'
                    });
                },100);

                setTimeout(function(){
                    $('#field_last_business_day').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu'
                    });
                },100);
            }

            for(var i = 0, i_ = activeInstance.roles.length; i < i_; i ++) {
                if (this.roles[i].name == 'user') {
                    this.roles[i].selected = (user_role == 'user');
                } else if (this.roles[i].name == 'freelancer') {
                    this.roles[i].selected = (user_role == 'freelancer');
                } else if (this.roles[i].name == 'inactive') {
                    this.roles[i].selected = (user_role == 'inactive');
                }
            }
        }
    },
    methods:{
        /*
        checkFreelancerRole:function(){
            setTimeout(function(){
                activeInstance.roles.forEach(function(role){
                    console.log(role);
                    if(role.name=='freelancer' && role.selected==true){
                        activeInstance.user_is_freelancer = 1;
                        console.log('user is freelancer');
                    }

                    if(role.name=='freelancer' && role.selected==false){
                        activeInstance.user_is_freelancer = 0;
                        console.log('user is not a freelancer');

                        setTimeout(function(){
                            $('#field_first_business_day').datetimepicker({
                                format: 'YYYY-MM-DD',
                                locale: 'hu'
                            });
                        },100);

                        setTimeout(function(){
                            $('#field_last_business_day').datetimepicker({
                                format: 'YYYY-MM-DD',
                                locale: 'hu'
                            });
                        },100);

                    }
                });
            },100);
        },
        */
        getDivisionTitles: function() {
            $.each(this.divisions, function(i,item) {
                if (item.id == activeInstance.user[0].division_id) {

                    $.each(item.titles, function(i, title) {
                        if (activeInstance.user_division_titles.indexOf(title.id) == -1) {
                            title.selected = false;
                        } else {
                            title.selected = true;
                        }
                    });

                    activeInstance.active_division_titles = item.titles;
                    return false;
                }
            });
        },
        showMigrationPanel: function(projects) {
            axios.get(baseURL+'/api/user/account_manager/list')
            .then(function (users_response) {

                activeInstance.account_managers = users_response.data;

                var account_managers = "";

                for(var a = 0, a_ = activeInstance.account_managers.length; a < a_; a ++) {
                    account_managers += '<option value="'+activeInstance.account_managers[a].id+'">'+activeInstance.account_managers[a].firstname+' '+activeInstance.account_managers[a].lastname+'</option>';
                }

                var html = '<div><ul>';

                console.log('projects:');
                console.log(activeInstance.projects);

                for(var i = 0, i_ = activeInstance.projects.length; i < i_; i ++) {
                    html += '<li><a href="'+activeInstance.projects[i].id+'">'+activeInstance.projects[i].name+'</a><select class="project_migration_field form-control" data-project-id="'+projects[i].id+'" style="display: inline-block;width: auto;margin-left: 20px;" class="form-control">'+account_managers+'</select></li>';
                }

                html += '</ul></div>';

                var dialog = bootbox.dialog({
                    title: 'Projektek migrálása',
                    message: html,
                    buttons: {
                        cancel: {
                            label: "Mégse",
                            className: 'btn-warning',
                            callback: function() {

                            }
                        },
                        ok: {
                            label: "Mentés",
                            className: 'btn-success',
                            callback: function() {
                                var fields = $(".modal-body .project_migration_field");

                                var project_migrations = [];

                                fields.each(function(i, item) {
                                    project_migrations.push({
                                        project_id: item.getAttribute('data-project-id'),
                                        new_supervisor_id: item.value
                                    });
                                });

                                showLoadingOverlay();
                                axios.post(baseURL+'/api/user/migrate', {'project_migrations':project_migrations})
                                .then(function (response) {

                                    activeInstance.currently_removing = true;
                                    activeInstance.delete();
                                    $('body').LoadingOverlay("hide");

                                })
                                .catch(function (error) {
                                    console.log(error);
                                    $('body').LoadingOverlay("hide");
                                });
                            }
                        }
                    }
                });
            })
            .catch(function (error) {
                console.log(error);
                $('body').LoadingOverlay("hide");
            });
        },
        removeUserRequest: function() {
            showLoadingOverlay();
            axios.post(baseURL+'/api/user/destroy', {
                user_id: activeInstance.user[0].id
            })
            .then(function (response) {
                $('body').LoadingOverlay("hide");
                successNotification(response.data.message);

                setTimeout(function() {
                    window.location.href = baseURL+"/admin/users";
                }, 3000);
            })
            .catch(function (error) {

                if(error.response.status == 400)
                {
                    if(error.response.data.result == 'migrations_required'){
                        activeInstance.projects = error.response.data.projects;
                        setTimeout(function(){
                            activeInstance.showMigrationPanel(activeInstance.projects);
                        },100);
                    }
                }

                console.log(error.response.data);
                $('body').LoadingOverlay("hide");

            });
        },
        delete: function(user) {

            if (!activeInstance.currently_removing) {
                bootbox.confirm('Biztosan törölni szeretnéd a felhasználót?', function(value){
                    if (value) {
                        activeInstance.removeUserRequest();
                    }
                });
            } else {
                activeInstance.removeUserRequest();
            }
        },
        validateInputData:function(){
            $('.field').removeClass('error');
            var validation = true;

            //VALIDATE EVERYTHING!!

            //PERSONAL DATA
            if(activeInstance.user[0].firstname.length < 2){
                validation = false;
                errorNotification('A vezetéknév túl rövid!');
                $('#field_first_name').addClass('error');
            }

            if(activeInstance.user[0].lastname.length < 2){
                validation = false;
                errorNotification('A keresztnév túl rövid!');
                $('#field_last_name').addClass('error');
            }

            if(validateEmail(activeInstance.user[0].email) == false){
                validation = false;
                errorNotification('Az email cím nem megfelelő!');
                $('.bootbox-body').find('#field_email').addClass('error');
            }

            if(activeInstance.user_basic_role == 'user' && activeInstance.user[0].last_business_day == null && activeInstance.user[0].leaving==1){
                validation = false;
                errorNotification('Az utolsó munkanapot ki kell tölteni kilépő alkalmazott esetén.');
                $('.bootbox-body').find('#field_last_business_day').addClass('error');
            }

            var first_business_day = moment(activeInstance.user[0].first_business_day);
            var last_business_day =  moment(activeInstance.user[0].last_business_day);

            if( activeInstance.user_basic_role == 'user' && first_business_day.isValid() !=true ){
                validation = false;
                errorNotification('Az első munkanap nem érvényes dátum.');
                $('#field_first_business_day').addClass('error');
            }

            if( last_business_day.isValid() !=true && activeInstance.user[0].leaving==1 ){
                validation = false;
                errorNotification('Az utolsó munkanap nem érvényes dátum.');
                $('#field_last_business_day').addClass('error');
            }

            if( first_business_day >= last_business_day ){
                validation = false;
                errorNotification('Az első munkanap nem lehet az utolsó után.');
                $('#field_first_business_day').addClass('error');
                $('#field_last_business_day').addClass('error');
            }

            /* PASSWORD IS VALIDATED BY ANOTHER METHOD */

            //HR DATA

            if( $('.field_overhead_cost').length > 0 ){

                if(activeInstance.user[0].overhead_cost < 1){
                    validation = false;
                    errorNotification('Az overhead költség túl alacsony');
                    $('.bootbox-body').find('#field_post_overhead_cost').addClass('error');
                }

            }

            if(activeInstance.user_basic_role == 'user' && activeInstance.user[0].total_days_off< 1){
                validation = false;
                errorNotification('A szabadnapok száma túl alacsony.');
                $('#field_total_days_off').addClass('error');
            }

            if(activeInstance.user[0].division_id<1){
                validation = false;
                errorNotification('Nincs kiválasztva divízió.');
                $('.bootbox-body').find('#field_vat_number').addClass('error');
            }

            return validation;
        },
        getAvailableRoles:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/list/roles/available',function(response){
                $('body').LoadingOverlay("hide");

                $.each(response,function(index,role){
                    role.selected = false;
                });

                activeInstance.roles = response;
                activeInstance.getUserRoles();
            }).bind(this);
        },
        getDivisions:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/divisions/get/active',function(response){
                $('body').LoadingOverlay("hide");

                activeInstance.divisions = response;

                activeInstance.getDivisionTitles();
            });
        },
        getUserRoles:function(){
            var user_id = 1;

            showLoadingOverlay();
            Vue.http.post(baseURL+'/api/user/list/roles/assigned',{'user_id':activeInstance.user[0].id},function(response){
                $('body').LoadingOverlay("hide");

                activeInstance.assigned_roles = response;

                $.each(activeInstance.assigned_roles, function(index_main,assigned_role){

                    $.each(activeInstance.roles, function(index,role){
                        if(role.id == assigned_role.id)
                        {
                            role.selected = true;
                        }
                    });
                });
            }).bind(this);
        },
        getAllCompany:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/company/list/all',function(response){
                $('body').LoadingOverlay("hide");

                $.each(response,function(index,company){
                    company.selected = false;
                });

                activeInstance.companies = response;
                activeInstance.getUserCompanies();
            }).bind(this);
        },
        getUserCompanies:function(){
            var user_id = 1;

            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/user/list/companies/'+user_id,function(response){
                $('body').LoadingOverlay("hide");

                activeInstance.assigned_companies = response;
                $.each(activeInstance.assigned_companies, function(index_main,assigned_company){

                    $.each(activeInstance.companies, function(index,company){
                        if(company.id == assigned_company.id){
                            company.selected = true;
                        }
                    });
                });

            }).bind(this);
        },
        checkPassword:function(){
            re = /^\w+$/;
            if(activeInstance.password != "" && activeInstance.password == activeInstance.password_verify) {
                if(activeInstance.password.length < 6) {
                    errorNotification("Hiba: A jelszónak legalább 6 karakter hosszúnak kell lennie!");
                    return false;
                }
                re = /[0-9]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy számnak szerepelnie kell!");
                    return false;
                }
                re = /[a-z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy kisbetűnek szerepelnie kell (a-z)!");
                    return false;
                }
                re = /[A-Z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy nagybetűnek szerepelnie kell (A-Z)!");
                    return false;
                }
            } else {
                if(activeInstance.password==""){
                    errorNotification("Hiba: A jelszó nincs kitöltve");
                    return false;
                }
                else{
                    errorNotification("Hiba: A jelszó nem egyezik a megerősítéssel.");
                    return false;
                }

            }
            return true;
        },
        togglePasswordField:function(){
            if(activeInstance.passwordFieldIsActive == true){
                activeInstance.passwordFieldIsActive = false;
            }
            else{
                activeInstance.passwordFieldIsActive = true;
            }
        },
        updateUserPassword:function(){
            var validated = activeInstance.checkPassword();
            if(validated == true){
                bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                    if(value==true){
                        showLoadingOverlay();
                        Vue.http.post(baseURL+'/admin/user/update/password', {'user':activeInstance.user,'password':activeInstance.password}).then(function(response){
                            activeInstance.togglePasswordField();
                            activeInstance.password="";
                            activeInstance.password_verify="";
                            $('body').LoadingOverlay("hide");

                            successNotification('Jelszó sikeresen frissítve.');

                        }).bind(this);
                    }
                });
            }
        },
        updateUserNameAndEmail:function(){
            bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/user/update/name_and_email', {'user':activeInstance.user,'password':activeInstance.password}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A felhasználó adatai sikeresen frissítve.');
                    }).bind(this);
                }
            });
        },
        //SAVE
        save:function(){

            if (activeInstance.original_email != activeInstance.user[0].email) {
                bootbox.confirm({
                    message: "Biztosan módosítani szeretnéd a felhasználó email címét?",
                    buttons: {
                        confirm: {
                            label: 'Igen',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'Nem',
                            className: 'btn-danger'
                        }
                    },
                    callback: function (result) {
                        if (result == false) {
                            activeInstance.user[0].email = activeInstance.original_email;
                        }
                        //VALIDATION
                        validation = activeInstance.validateInputData();

                        if(validation == true){
                            showLoadingOverlay();
                            Vue.http.post(baseURL+'/admin/user/update',{user:activeInstance.user[0], division_titles: activeInstance.active_division_titles}).then(function(response){
                                $('body').LoadingOverlay("hide");
                                console.log(response);
                                successNotification('Felhaszálói adatok sikeresen mentve');

                                showLoadingOverlay();
                                Vue.http.post(baseURL+'/admin/user/modify/roles',{'roles':activeInstance.roles, 'user_id':activeInstance.user[0].id}).then(function(response){
                                    $('body').LoadingOverlay("hide");
                                    console.log(response);
                                    successNotification('Szerepkörök sikeresen mentve');

                                    setTimeout(function(){
                                        location.href=baseURL+"/admin/users";
                                    },600);
                                });
                            }, function(response) {
                                $('body').LoadingOverlay("hide");
                                errorNotification(response.data);
                            });
                        }
                    }
                });
            }
            else{
                bootbox.confirm({
                    message: "Biztosan mented a felasználó adatait?",
                    buttons: {
                        confirm: {
                            label: 'Igen',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'Nem',
                            className: 'btn-danger'
                        }
                    },
                    callback: function (result) {
                        if (result == false) {
                            activeInstance.user[0].email = activeInstance.original_email;
                            return true;
                        }
                        //VALIDATION
                        validation = activeInstance.validateInputData();

                        if(validation == true){
                            showLoadingOverlay();
                            Vue.http.post(baseURL+'/admin/user/update',{user:activeInstance.user[0], division_titles: activeInstance.active_division_titles}).then(function(response){
                                $('body').LoadingOverlay("hide");
                                console.log(response);
                                successNotification('Felhaszálói adatok sikeresen mentve');

                                showLoadingOverlay();
                                Vue.http.post(baseURL+'/admin/user/modify/roles',{'roles':activeInstance.roles, 'user_id':activeInstance.user[0].id}).then(function(response){
                                    $('body').LoadingOverlay("hide");
                                    console.log(response);
                                    successNotification('Szerepkörök sikeresen mentve');

                                    setTimeout(function(){
                                        location.href=baseURL+"/admin/users";
                                    },600);
                                });
                            }, function(response) {
                                $('body').LoadingOverlay("hide");
                                errorNotification(response.data);
                            });
                        }
                    }
                });
            }
        }
    }
});